export const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString(); // Customize the format if needed
};